var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifyError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "41px",
    viewBox: "0 0 40 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u9519\u8BEF_40dp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "0%",
    x2: "0%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E25A5A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E45784",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 208,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0214\\u66F4\\u65B0-\\u901A\\u77E5\\u6837\\u5F0F",
    transform: "translate(-1076.000000, -223.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-11\\u5907\\u4EFD-2",
    transform: "translate(1058.000000, 202.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9519\\u8BEF_40dp",
    transform: "translate(18.000000, 21.500000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(5.000000, 5.000000)",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2166667,0 L30,8.78333333 L30,21.2166667 L21.2166667,30 L8.78333333,30 L0,21.2166667 L0,8.78333333 L8.78333333,0 L21.2166667,0 Z M19.8333333,3.33333333 L10.1666667,3.33333333 L3.33333333,10.1666667 L3.33333333,19.8333333 L10.1666667,26.6666667 L19.8333333,26.6666667 L26.6666667,19.8333333 L26.6666667,10.1666667 L19.8333333,3.33333333 Z M18.885,9 L21,11.115 L17.115,15 L21,18.885 L18.885,21 L15,17.115 L11.115,21 L9,18.885 L12.885,15 L9,11.115 L11.115,9 L15,12.885 L18.885,9 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifyError);
export default __webpack_public_path__ + "static/media/notify_error.d6f6cd13d55c92d4e6dd01bef453045e.svg";
export { ForwardRef as ReactComponent };